import React from 'react';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { SaveAuditLogs } from '../../../../../../data/UserAuditLogs';
import { postAPI_UsersPassword_ForgotPassword } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

function GenerateResetPasswordLink({ email, userName, id, serviceProvider }) {
  const handleCopy = (email, id) => {
    const auditData = {
      groupId: getGroupID(),
      itemId: id,
      action: "Generate Reset Password link by " + userName,
      content: { email: email, },
      logType: "UsersRoles",
      createdBy: userName
    };
    SaveAuditLogs(auditData);
    let data = {
      email: email,
      serviceProvider: serviceProvider,
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_UsersPassword_ForgotPassword}`,
      data: data,
    })
      .then((resnew) => {
        navigator.clipboard.writeText(resnew.data.url);
        NotificationManager.success(
          '',
          'Link copied to clipboard.',
          3000,
          null,
          null,
          'success'
        );
      }, (error) => {
        var errormsg = "";
        if (error.response.data.message === "ThrottlerException: Too Many Requests") {
          errormsg = "You have attempted many times. Please try after sometime.";
        }
        NotificationManager.error(
          '',
          errormsg,
          3000,
          null,
          null,
          'error'
        );
        console.log('eee.data', error);
      })
      .catch((err) => console.error(err));
  };

  return (
    <Button color="primary" size="sm" outline onClick={() => handleCopy(email, id)}>
      Reset Password Link
    </Button>
  );
}
const mapStateToProps = ({ settings }) => {
  const { userName, serviceProvider } = settings;
  return { userName, serviceProvider };
};
export default injectIntl(connect(mapStateToProps, {})(GenerateResetPasswordLink));
